import React from 'react';
import { ColumnParams } from '../ColumnTemplate';

const ReadonlyColumn = (props: ColumnParams) => {
    return <div>{props.value}</div>;
};

export default ReadonlyColumn;